import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import AdminProfile from './views/AdminProfile.vue'
import Login from './views/Login.vue'
import MessageForm from './views/MessageForm.vue'
import StudentList from './views/StudentList.vue'
import StudentDetail from './views/StudentDetail.vue'
import OnlineEnrollmentDetail from './views/OnlineEnrollmentDetail.vue'
import StudentForm from './views/StudentForm.vue'
import Templates from './views/Templates.vue'
import Statistics from './views/Statistics.vue'
import DuePayments from './views/DuePayments.vue'
import OnlineEnrollments from './views/OnlineEnrollments.vue'
import SetNewPassword from './views/SetNewPassword.vue'

import store from './store/'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/student-list',
      name: 'student-list',
      component: StudentList
    },
    {
      path: '/student-detail/:id',
      name: 'student-detail',
      component: StudentDetail
    },
    {
      path: '/update-student/:id',
      name: 'update-student',
      component: StudentForm
    },
    {
      path: '/student-form',
      name: 'student-form',
      component: StudentForm
    },
    {
      path: '/templates',
      name: 'templates',
      component: Templates
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: Statistics
    },
    {
      path: '/due-payments',
      name: 'due-payments',
      component: DuePayments
    },
    {
      path: '/online-enrollments',
      name: 'online-enrollments',
      component: OnlineEnrollments
    },
    {
      path: '/online-enrollment-detail/:id',
      name: 'online-enrollment-detail',
      component: OnlineEnrollmentDetail
    },
    {
      path: '/admin-profile/:id',
      name: 'admin-profile',
      component: AdminProfile
    },
    {
      path: '/reset-password/:uid/:token',
      namee: 'reset-password',
      component: SetNewPassword
    },
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/message',
      name: 'message',
      component: MessageForm
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./views/About.vue')
    },
    { path: '*', redirect: { name: 'login' } }
  ]
})
router.beforeEach((to, from, next) => {
  if (to && (to.name === 'login' || to.name === 'setNewPassword') && (store.state.admin !== null && !!store.state.admin.session_key)) {
    return next({ name: 'home' })
  }

  return next()
})

export default router
